import React, { PropTypes } from 'react'
import AlbumItem from './AlbumItem/AlbumItem'

function Albums({ albums, params, children }) {

  if (params.id) {
    return (
      <div>{children}</div>
    )
  } else {
    return (
      <div className="row">
        <ul>
          {albums.map(album => <li key={album.id}><AlbumItem album={album}/></li>)}
        </ul>
      </div>
    )
  }
}


Albums.propTypes = {
  albums: PropTypes.array
}

export default Albums



/** WEBPACK FOOTER **
 ** ./src/components/Media/Photos/Albums/Albums.jsx
 **/